document.addEventListener('DOMContentLoaded', () => {
    const slides = document.querySelectorAll('.index-stages__slide');
    const stages = document.querySelectorAll('.index-stages__stage'); // Получаем элементы стадий
    if (slides.length === 0 || stages.length === 0) {
        return;
    }

    const stageProgressBars = document.querySelectorAll('.index-stages__stage-progress-state');
    const autoSlideDuration = 20 * 1000; // Время показа каждого слайда (20 секунд)
    let currentIndex = 0; // Индекс текущего активного слайда
    let autoSlideInterval; // Интервал для автоматического переключения

    // Функция для обновления активной стадии
    const updateActiveStage = (index) => {
        // Удаляем класс 'active' со всех стадий
        stages.forEach((stage) => stage.classList.remove('active'));
        // Добавляем 'active' только выбранной стадии
        const activeStage = stages[index];
        if (activeStage) {
            activeStage.classList.add('active');
        }
    };

    // Обновление прогресс-бара
    const updateProgressBar = (index) => {
        // Сбрасываем анимацию для всех прогресс-баров
        stageProgressBars.forEach((bar) => {
            bar.style.transition = 'none'; // Отключаем текущую анимацию
            bar.style.width = '0%'; // Возвращаем прогресс-бары к началу
        });

        // Перезапускаем анимацию для текущего прогресс-бара
        const currentBar = stageProgressBars[index];
        if (currentBar) {
            setTimeout(() => {
                currentBar.style.transition = `width ${autoSlideDuration}ms linear`; // Задаем время анимации
                currentBar.style.width = '100%'; // Заполняем текущий прогресс-бар
            }, 50); // Небольшая задержка для корректного сброса анимации
        }
    };

    // Функция переключения слайдов
    const showSlide = (index, isUserInteraction = false) => {
        // Снимаем класс 'active' со всех слайдов
        slides.forEach((slide) => slide.classList.remove('active'));

        // Добавляем 'active' только выбранному слайду
        slides[index].classList.add('active');

        // Обновляем прогресс-бар
        updateProgressBar(index);

        // Обновляем текущий индекс
        currentIndex = index;

        // Прокручиваем в центр только при взаимодействии пользователя
        if (isUserInteraction) {
            slides[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        // Обновляем активную стадию
        updateActiveStage(index);
    };

    // Функция автоматического переключения слайдов
    const startAutoSlide = () => {
        autoSlideInterval = setInterval(() => {
            const nextIndex = (currentIndex + 1) % slides.length; // Переход к следующему слайду
            showSlide(nextIndex); // Переходим без взаимодействия пользователя
        }, autoSlideDuration); // Автоматическое переключение через указанное время
    };

    // Остановка автоматического переключения
    const stopAutoSlide = () => {
        clearInterval(autoSlideInterval);
    };

    const activateStage = (event) => {
            stopAutoSlide(); // Останавливаем автоматическое переключение

            // Находим родительский элемент 'index-stages__stage'
            const stage = event.target.closest('.index-stages__stage');
            if (stage) {
                // Определяем индекс стадии
                const stagesContainer = stage.parentElement;
                const index = Array.from(stagesContainer.children).indexOf(stage);

                // Показать выбранный слайд с явным указанием взаимодействия пользователя
                if (index >= 0) {
                    showSlide(index, true);
                }

                startAutoSlide(); // Перезапуск автоматического переключения
            }
    };

    // Обработка клика и клавиатуры на заголовке стадии
    document.querySelectorAll('.index-stages__stage-title').forEach((title) => {
        title.setAttribute('tabindex', '0');
        title.setAttribute('role', 'button');
        title.setAttribute('aria-label', `Показать этап: ${title.textContent.trim()}`);

        title.addEventListener('click', activateStage);
        title.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                activateStage(event);
            }
        });
    });

    // Инициализация: показываем первый слайд и запускаем автоматическое переключение
    showSlide(currentIndex, false); // Без прокрутки при загрузке страницы
    startAutoSlide();
});
